import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { useRouter } from 'vue-router';

import Environment from '../../environment';
import { ErrorLogger } from './ErrorLogger';

export class SentryLogger implements ErrorLogger {
  init(app: App): void {
    Sentry.init({
      app,
      environment: Environment.SENTRY_ENVIRONMENT,
      dsn: Environment.SENTRY_DSN,
      integrations: [
        Sentry.browserTracingIntegration({ router: useRouter() }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 0.8,
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/platform\.beconfident\.app/,
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 0.5,
    });
  }

  captureException(error: unknown): void {
    Sentry.captureException(error);
  }
}
